import { render, staticRenderFns } from "./bidding03.vue?vue&type=template&id=2f5a4d50&scoped=true&"
import script from "./bidding03.vue?vue&type=script&lang=js&"
export * from "./bidding03.vue?vue&type=script&lang=js&"
import style0 from "./bidding03.vue?vue&type=style&index=0&id=2f5a4d50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5a4d50",
  null
  
)

export default component.exports